import type {z} from "zod";
import {createValidationIssue} from "@project/i18n";
import {UpdateExpedientBody} from "@project/sdk/sales/zod";
import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {
  expedientFieldLabelIds,
  expedientValidationMessages,
} from "../../../messages/expedients.messages";

const fields = UpdateExpedientBody;
export const updateExpedientNameSchema = requiredStringSchema(
  fields.shape.name,
  expedientFieldLabelIds.name,
);
export const updateExpedientAliasSchema = requiredStringSchema(
  fields.shape.alias,
  expedientFieldLabelIds.alias,
);
export const updateExpedientDescriptionSchema = requiredStringSchema(
  fields.shape.description,
  expedientFieldLabelIds.description,
);
const updateExpedientFormFieldsSchema = UpdateExpedientBody.strict().extend({
  size: fields.shape.size.strict(),
  helicopter: fields.shape.helicopter.strict(),
  classification: fields.shape.classification.unwrap().options[0].strict().nullable().optional(),
  structure: fields.shape.structure.unwrap().options[0].strict().nullable().optional(),
  visualAid: fields.shape.visualAid.unwrap().options[0].strict().nullable().optional(),
  fireFighting: fields.shape.fireFighting.unwrap().options[0].strict().nullable().optional(),
  misc: fields.shape.misc.unwrap().options[0].strict().nullable().optional(),
  name: updateExpedientNameSchema,
  alias: updateExpedientAliasSchema,
  description: updateExpedientDescriptionSchema,
});
export const updateExpedientFormSchema = updateExpedientFormFieldsSchema.superRefine(
  (payload, ctx) => {
    if (new Set(payload.standard).size !== payload.standard.length)
      ctx.addIssue({
        ...createValidationIssue({id: expedientValidationMessages.standardUnique.id}),
        path: ["standard"],
      });
    for (const [group, fixed] of [
      [
        "visualAid",
        ["perimeterLights", "statusLights", "floodLight", "obstructionLight", "windSock", "tdPm"],
      ],
      ["fireFighting", ["monitor", "diffs", "branchPipe", "safeDeck"]],
      ["misc", ["deIcing", "access", "safetyNet"]],
    ] as const) {
      const options = payload[group]?.additionalOptions;
      if (options)
        for (const key of Object.keys(options))
          if (!key.trim() || fixed.some((member) => member === key))
            ctx.addIssue({
              ...createValidationIssue({id: expedientValidationMessages.equipmentOptionName.id}),
              path: [group, "additionalOptions", key],
            });
    }
  },
);
export type UpdateExpedientFormPayload = z.output<typeof updateExpedientFormSchema>;
export const draftUpdateExpedientFormSchema = updateExpedientFormFieldsSchema.partial();
export type DraftUpdateExpedientFormPayload = z.output<typeof draftUpdateExpedientFormSchema>;
